import React, { FC, useEffect, useMemo } from 'react';
import { Box } from '@wix/design-system';
import useMobileMediaQuery from '@components/Hooks/useMobileMediaQuery';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';
import FilterPanel from './FilterPanel';
import s from './Templates.module.scss';
import TemplateGallery from './TemplateGallery';
import TemplateGalleryMobile from './TemplateGallery/TemplateGalleryMobile';
import FilterToggle from './FilterPanel/FilterToggle';
import MobileActions from './MobileActions';
import TemplateGalleryPageHeader from './TemplateGalleryPageHeader';
import { useTemplatesBi } from '@components/Hooks/useTemplatesBi';
import GenericErrorState from './ErrorStates/GenericErrorState';
import HeaderBanner from '@components/HeaderBanner';

const Templates: FC = () => {
  const {
    state: { isMobileUserAgent, filterOpen, error },
  } = useTemplatesContext();
  const isMobileView = useMobileMediaQuery(isMobileUserAgent);
  const { logBiPageView } = useTemplatesBi({ is_mobile: isMobileView });

  useEffect(() => {
    logBiPageView();
  }, []);

  const calcWidth = useMemo(() => {
    return filterOpen ? '261px' : '24px';
  }, [filterOpen]);

  return (
    <Box display="block" dataHook="templates-page" backgroundColor="white">
      <div className={s.stickyHeader}>
        <TemplateGalleryPageHeader />
      </div>
      {error ? (
        <Box height={`calc(100vh - ${isMobileView ? '54px' : '72px'})`}>
          <GenericErrorState />
        </Box>
      ) : (
        <Box direction="vertical">
          <HeaderBanner
            isMobileView={isMobileView}
            className="bannerWrapperBoxShadowYellow"
            subtitleKey="marketplace.templates-page.banner-studio.subtitle"
            titleKey="marketplace.templates-page.banner-studio.title"
          />
          <Box>
            {isMobileView ? (
              <Box
                className={s.gridSide}
                direction="vertical"
                width="100%"
                position="relative"
              >
                <MobileActions />
                <TemplateGalleryMobile />
              </Box>
            ) : (
              <>
                <FilterPanel />
                <Box
                  className={s.gridSide}
                  direction="vertical"
                  width={`calc(100% - ${calcWidth})`}
                  position="relative"
                >
                  <FilterToggle />
                  <TemplateGallery />
                </Box>
              </>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Templates;
